import React, { Component } from 'react';
import dayjs from 'dayjs';

class SlipList extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget full-width dsr-table">
          <header></header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Slip List">
              <thead>
                <tr data-header={true}>
                  <th>Date</th>
                  <th>Slip #</th>
                  <th>Staff</th>
                  <th>Customer</th>
                  <th>Vehicle</th>
                  <th>Product</th>
                  <th>Rate</th>
                  <th>Qty</th>
                  <th>Amount</th>
                  <th>Amount received</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((item, i) => (
                  <tr key={i}>
                    <td> {dayjs(item.time_stamp).format('DD/MM/YYYY')}</td>
                    <td> {item.credit_slip.slip_number}</td>
                    <td>
                      {item.cashier.first_name}
                      {item.cashier.last_name}
                    </td>
                    <td>
                      {item.customer.first_name}
                      {item.customer.last_name}
                    </td>
                    <td>{item.credit_slip.vehicle_number || '---'}</td>
                    <td> {item.credit_slip.product.product}</td>
                    <td>
                      {' '}
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.credit_slip.product.price)}
                    </td>
                    <td> {item.quantity}</td>
                    <td>
                      {' '}
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.amount || 0)}
                    </td>
                    <td>
                      {' '}
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.amount_received || 0)}
                    </td>
                    <td>
                      {' '}
                      {new Intl.NumberFormat('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                      }).format(item.balance || 0)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
export default SlipList;
